// extracted by mini-css-extract-plugin
export default {"container":"Clients_container__5SPLK","progressContainer":"Clients_progressContainer__JCACv","datagrid_container":"Clients_datagrid_container__qK9-R"};